import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    speed: translate({ id: 'gps.eventslist.view.speed' }),
  }))

  return api
}
